
(async () => {

  const fetchOwnerStats = async () => {
    try {
      const ownerStatsResponse = await axios.get('https://api.pandastats.io/owners/summary');

      if (ownerStatsResponse.status === 200) {
        const data = ownerStatsResponse.data;

        const uni_o = data.UniqueOwners.toLocaleString(undefined,{ minimumFractionDigits: 0, maximumFractionDigits: 0 });
        const uno = document.getElementById('unique-owners');
        uno.innerHTML = `${uni_o}`;

        const most_pandas = data.MostOwned
        const ens_response1 = await axios.get('https://api.pandastats.io/owners?$filter=address%20eq%20%27' + most_pandas + '%27');
        const ens_name1 = ens_response1?.data?.[0]?.EnsAddress ?? null;
        const owner_displayname1 = ens_name1 ? ens_name1 : most_pandas.substring(0,5);
        const mp = document.getElementById('most-pandas-owned');
        mp.innerHTML = '<a href="profile.html?address=' + `${most_pandas}` + '">' + `${owner_displayname1}` + '</a>';  

        const most_pandas_count = data.MostOwnedCount.toLocaleString(undefined,{ minimumFractionDigits: 0, maximumFractionDigits: 0 });
        const mp_count = document.getElementById('most-pandas-owned-count');
        mp_count.innerHTML = `${most_pandas_count}`; 

        const most_points = data.TopBalance
        const ens_response2 = await axios.get('https://api.pandastats.io/owners?$filter=address%20eq%20%27' + most_points + '%27');
        const ens_name2 = ens_response2?.data?.[0]?.EnsAddress ?? null;
        const owner_displayname2 = ens_name2 ? ens_name2 : most_points.substring(0,5);
        const mpo = document.getElementById('highest-balance');
        mpo.innerHTML = '<a href="profile.html?address=' + `${most_points}` + '">' + `${owner_displayname2}` + '</a>'; 

        const most_points_count = data.TopBalanceCount.toLocaleString(undefined,{ minimumFractionDigits: 0, maximumFractionDigits: 0 });
        const mpo_count = document.getElementById('highest-balance-count');
        mpo_count.innerHTML = `${most_points_count}`; 

        const highest_daily = data.TopDaily
        const ens_response3 = await axios.get('https://api.pandastats.io/owners?$filter=address%20eq%20%27' + highest_daily + '%27');
        const ens_name3 = ens_response3?.data?.[0]?.EnsAddress ?? null;
        const owner_displayname3 = ens_name3 ? ens_name3 : highest_daily.substring(0,5);
        const hpe = document.getElementById('highest-point-earner');
        hpe.innerHTML = '<a href="profile.html?address=' + `${highest_daily}` + '">' + `${owner_displayname3}` + '</a>'; 

        const highest_daily_count = data.TopDailyCount.toLocaleString(undefined,{ minimumFractionDigits: 0, maximumFractionDigits: 0 });
        const hpe_count = document.getElementById('highest-point-earner-count');
        hpe_count.innerHTML = `${highest_daily_count}` + '<span class="text-muted fs-14 fw-bold">/day</span>'; 

        

      } else {
        console.error('Error fetching data:', ownerStatsResponse.statusText);
      }
    } catch (error) {
      console.error('Error fetching data:', error.message);
    }
  };

  const fetchOwners = async () => {
    try { 
      const table_container = document.querySelector('#owners-table-container');
      table_container.style.display = 'none';

      const spinner = document.querySelector('#loading-spinner-owners-table');
      spinner.style.display = 'block';

      const response = await axios.get('https://api.pandastats.io/owners');

      table_container.style.display = 'block';
      spinner.style.display = 'none';

      

      if (response.status === 200) {
        const owners_table = response.data;      

        $('#owners-table').DataTable({
          order: [[2, 'desc']],
          data: owners_table,
          "bLengthChange": false,
          "pageLength": 10,
          columns: [
              { title: 'Address', data: 'Address', orderable: false,
                render: function (data, type, row, meta) {
                  const owner_displayname = row.EnsAddress ? row.EnsAddress : data.substring(0,5) + '...' + data.substring(data.length-5);
                  return type === 'display'
                      ? '<a href="profile.html?address=' + data + '">' + owner_displayname + '</a>'
                      : data;
                },
              },
              { title: 'EnsName', data: 'EnsAddress', className: 'dt-body-right', visible: false },
              { title: 'Pandas Owned', data: 'TokenCount', className: 'dt-body-right' },
              { title: 'Pandas Listed', data: 'OnsaleCount', className: 'dt-body-right' },
              { title: 'Points Balance', data: 'PointsBalance', className: 'dt-body-right', render: $.fn.dataTable.render.number(',', '.', 0, '') },
              { title: 'Points/day', data: 'PointsDaily', className: 'dt-body-right', render: $.fn.dataTable.render.number(',', '.', 0, '') },
              { title: '30d Volume (Ξ)', data: '_30dVolume', className: 'dt-body-right', render: $.fn.dataTable.render.number(',', '.', 2, '') },

          ],
      });

      } else {
        console.error('Error fetching data:', response.statusText);
      }
    } catch (error) {
      console.error('Error fetching data:', error.message);
    }
  };
  
  fetchOwnerStats();
  fetchOwners();

})();